export const getActiveElement = (hostElement: HTMLElement): Element | null => {
    return hostElement.shadowRoot!.activeElement;
};
